module.exports = __webpack_public_path__ + "img/adminDownApp.ad69761a.svg";